<template>
  <div 
    class="item"
    :style="{
      maxWidth: `${props.size}px`,
      maxHeight: `${props.size}px`,
      minWidth: `${props.size}px`,
      minHeight: `${props.size}px`,
      borderWidth: `${props.borderSize}px`,
      backgroundColor: `${props.borderColor}`,
      borderColor: `${props.borderColor}`
    }"
  >
    <img 
      class="item__img"
      :style="{
        maxWidth: `${props.size - props.borderSize * 2}px`,
        maxHeight: `${props.size - props.borderSize * 2}px`,
        minWidth: `${props.size - props.borderSize * 2}px`,
        minHeight: `${props.size - props.borderSize * 2}px`,
        filter: props.blur ? 'blur(0.5px)' : 'none'
      }" 
      :src="props.src" 
      :alt="props.alt" 
      :width="props.size - props.borderSize * 2" 
      :height="props.size - props.borderSize * 2" 
    />
  </div>
</template>

<script setup>
  import { Props } from './props.js';
  //--------------------------
  const props = defineProps(Props());
</script>

<style lang="scss" scoped>
  @import './styles.scss';
</style>